import { render, staticRenderFns } from "./modelMapping.vue?vue&type=template&id=40f5a1e9&scoped=true&"
import script from "./modelMapping.vue?vue&type=script&lang=js&"
export * from "./modelMapping.vue?vue&type=script&lang=js&"
import style0 from "./modelMapping.vue?vue&type=style&index=0&id=40f5a1e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f5a1e9",
  null
  
)

export default component.exports